import { useLazyQuery, useQuery } from "@apollo/client";
import { CMS } from "../cms.queries";
import { CmsQuery, CmsQueryVariables } from "../../../__generated__/CmsQuery";

export const useCms = (id: number) => {
  return useQuery<CmsQuery, CmsQueryVariables>(CMS, { variables: { id } });
};

export const useLazyCms = () => {
  return useLazyQuery<CmsQuery, CmsQueryVariables>(CMS);
};
